var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var uniq = function (x) { return __spreadArray([], __read(new Set(x))); };
var Warning = (function () {
    function Warning(props) {
        var _this = this;
        this.element = props.element;
        this.id = "warning-" + props.element.getAttribute("data-warning");
        var closes = props.element.querySelectorAll(".js-warning-close");
        closes &&
            closes.forEach(function (close) {
                close.addEventListener("click", function (e) {
                    e.preventDefault();
                    _this.element.setAttribute("aria-hidden", "true");
                    _this.setCookie(_this.id, "1", 1440);
                });
            });
        this.element.setAttribute("aria-hidden", this.getCookie(this.id) == "1" ? "true" : "false");
    }
    Warning.prototype.setCookie = function (cname, cvalue, minutes) {
        var d = new Date();
        d.setTime(d.getTime() + minutes * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
    Warning.prototype.getCookie = function (cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    return Warning;
}());
var warnings = [];
var warningElements = document.querySelectorAll("[data-warning]");
if (warningElements) {
    warningElements.forEach(function (element) {
        warnings.push(new Warning({ element: element }));
    });
    var warningIds = warnings.map(function (w) { return w.id; });
    var warningIdsUnique = uniq(warningIds);
    if (warningIds.length !== warningIdsUnique.length) {
        console.error("All warning elements must have a unique data-warning value");
    }
}
